<section id="cookie" class="cookie-container">
  <div class="container">
    <div class="col-xs-10">
      <p>Wir verwenden Cookies. Wenn Sie damit einverstanden sind, klicken Sie sich weiter durch die Seite.</p>
    </div>
    <div class="col-xs-2 text-right">
      <span id="btn-cookie" class="cookie-btn btn btn-default" (click)="cookie($event)">OK</span>
    </div>
  </div>
</section>
